// Footer.js
import React from "react";
import {
  Box,
  Flex,
  VStack,
  Link,
  Text,
  Image,
  Heading,
  Divider,
  SimpleGrid,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import facebookIcon from "./Images/facebbok-icon.svg";
import instagramIcon from "./Images/instagram-icon.svg";
import logo from "./Images/himmats-logo.svg";
import coursesData from "./coursesData";

const navLinkStyles = {
  color: "#161616",
  fontSize: "11px",
  fontWeight: "300",
};

const Footer = () => {
  // Separate IGCSE vs A-Level
  const igcseCourses = coursesData.filter((course) => {
    const t = course.title.toLowerCase();
    return !(t.startsWith("as") || t.startsWith("alevel"));
  });
  const alevelCourses = coursesData.filter((course) => {
    const t = course.title.toLowerCase();
    return t.startsWith("as") || t.startsWith("alevel");
  });

  return (
    <Box
      bg="#F7FBFD"
      px={{ base: 6, md: 20 }}
      py={{ base: 8, md: 12 }}
      borderTopLeftRadius="24px"
      borderTopRightRadius="24px"
    >
      <Flex direction="column" gap={{ base: 6, md: 10 }}>
        <Flex
          direction={{ base: "column", md: "row" }}
          gap={{ base: 8, md: 16 }}
          justify={{ base: "center", md: "space-between" }}
        >
          <VStack
            alignItems={{ base: "center", md: "start" }}
            spacing={3}
            w={{ base: "100%", md: "240px" }}
            marginRight={{ base: "0px", md: "285px" }}
          >
            <Image
              src={logo}
              alt="logo-image"
              boxSize={{ base: "48px", md: "74px" }}
            />
            <Text
              color="#161616"
              fontSize="12px"
              fontWeight="400"
              textAlign={{ base: "center", md: "left" }}
            >
              Cambridge IGCSE Courses with AI Solutions on Himmats’ New Advanced
              Platform.
            </Text>
            <Flex gap={3}>
              <Link
                href="https://www.facebook.com/Himmats.education/"
                isExternal
              >
                <Image src={facebookIcon} alt="facebook-icon" />
              </Link>
              <Link
                href="https://www.instagram.com/himmats.education/"
                isExternal
              >
                <Image src={instagramIcon} alt="instagram-icon" />
              </Link>
            </Flex>
          </VStack>

          <SimpleGrid columns={{ base: 1, sm: 3 }} spacing={{ base: 6, md: 4 }} flex="1">
            <VStack
              align={{ base: "center", md: "start" }}
              spacing={2}
            >
              <Heading size="sm" color="#161616" fontWeight="500">
                Links
              </Heading>
              <Link
                as={RouterLink}
                to="/"
                {...navLinkStyles}
              >
                Home
              </Link>
              <Link
                as={RouterLink}
                to="/program"
                {...navLinkStyles}
              >
                Program
              </Link>
              <Link
                as={RouterLink}
                to="/courses"
                {...navLinkStyles}
              >
                Courses
              </Link>
              <Link
                as={RouterLink}
                to="/registration"
                {...navLinkStyles}
              >
                Registration
              </Link>
              <Link
                as={RouterLink}
                to="/#testimonials"
                {...navLinkStyles}
              >
                Testimonials
              </Link>
            </VStack>

            <VStack
              align={{ base: "center", md: "start" }}
              spacing={2}
            >
              <Heading size="sm" color="#161616" fontWeight="500">
                IGCSE Courses
              </Heading>
              {igcseCourses.map((c) => (
                <Link
                  key={c.id}
                  as={RouterLink}
                  to={`/classroom/${encodeURIComponent(c.id)}`}
                  {...navLinkStyles}
                >
                  {c.title}
                </Link>
              ))}
            </VStack>

            <VStack
              align={{ base: "center", md: "start" }}
              spacing={2}
            >
              <Heading size="sm" color="#161616" fontWeight="500">
                A‑level Courses
              </Heading>
              {alevelCourses.map((c) => (
                <Link
                  key={c.id}
                  as={RouterLink}
                  to={`/classroom/${encodeURIComponent(c.id)}`}
                  {...navLinkStyles}
                >
                  {c.title}
                </Link>
              ))}
            </VStack>
          </SimpleGrid>
        </Flex>

        <Divider borderColor="#D9D9D9" />

        <Text
          color="#161616"
          fontSize="11px"
          fontWeight="300"
          textAlign={{ base: "center", md: "left" }}
        >
          ©2024 all rights reserved
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer; 

